module.exports = __webpack_public_path__ + "img/danger-warning.203491d8.svg";